'use strict';

import marked, { Renderer } from 'marked';


const renderer = new Renderer();

renderer.heading = (text, level) => {
	level = 5; // forbid use of <h1>..<h4> for a better readability: always force to <h5>
	return `<h${level}>${text}</h${level}>`;
};


marked.setOptions({
	renderer,
	sanitize: true,
	headerIds: false,
	breaks: true,
	smartLists: true,
	smartypants: true,
});


export const compile = md => {
	if (!md) { return }
	return marked(md);
};
